<template>
  <div class="body evel-II">
    <div class="bg-white" v-show="!($refs&&$refs.resourcesDataSelector&&$refs.resourcesDataSelector.isShow || false)">
      <!-- <h2 class="body-title">添加培训计划</h2> -->
      <el-form ref="form" :rules="rules" :model="form" label-width="80px">
        <el-row class="layer-header-front">
          <el-col :span="24" class="pr20">
            <el-form-item label="课程名称" prop="trainingName" class="item">
              <el-input
                :disabled="$route.query.type == 'check'"
                v-model="form.trainingName"
                style="width: calc(100% - 160px);"></el-input>
              
              <el-button class="fa-pull-right" style="float: right;" @click="$router.back(-1)">返回</el-button>
            </el-form-item>
          </el-col>
        </el-row>
        <div class="pl20">
        <div class="f--c mb20">
          <h2>
            基本信息
          </h2>
          <span class="required" v-if="form.isMallImport" v-html="courseUtils.translateSourceName(form)"></span>
        </div>
        <el-row>
          <!-- <el-col :span="8" class="pr20">
            <el-form-item label="培训类型" prop="trainingCategoryName">
              <el-input
                @focus="showSelectTreeCategoryVisible"
                ref="trainingCategoryInput"
                clearable
                @clear="trainingCategoryClear"
                :disabled="$route.query.type == 'check'"
                v-model="form.trainingCategoryName">
              </el-input>
            </el-form-item>
          </el-col> -->
          <el-col :span="8" class="pr20">
            <el-form-item label="课程目录" prop="directoryId">
              <selectTree
                :props="{
                  value: 'id', // ID字段名
                  label: 'directoryName', // 显示名称
                  children: 'directoryList' // 子级字段名
                }"
                :options="catalogList"
                :value="form.directoryId"
                :disabled="$route.query.type == 'check'"
                @getValue="selectTreeChange"
              ></selectTree>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12" class="pr20">
            <el-form-item label="图片" prop="pictureUrl">
              <template v-if="$route.query.type == 'check'">
                <img width="150px" :src="form.pictureUrl" alt="">
              </template>
              <template v-else>
                <el-upload-e :dir="ossConstant.dir.mallCoursewareImage"
                             :limit="upload.imgLimit"
                             :drag="false"
                             :file-list="upload.productImgs"
                             :multiple="upload.isMultiple"
                             @onRemove="handleRemove"
                             @onSuccess="handleAvatarSuccess"
                             :accept="'.png,.jpg'">
                             <el-button size="small" type="text" icon="el-icon-upload">点击上传</el-button>
                </el-upload-e>
              </template>
              <el-dialog :visible.sync="upload.dialogVisible">
                <img width="100%" :src="upload.dialogImageUrl" alt="">
              </el-dialog>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="20" class="pr20">
            <el-form-item label="课程详情" prop="trainingContent">
              <quillEditor
                v-if="$route.query.type != 'check'"
                v-model="form.trainingContent"
                ref="myQuillEditor"
                :options="editorOption"
              ></quillEditor>
              <div v-else v-html="form.trainingContent"></div>
              <!-- <div style="display: none;">
                <el-upload-m :customId="'imgInput'" :dir="ossConstant.dir.courseware" @onBefore="uploadBefore" @onSuccess="uploadSuccess2" :accept="'.mp4,.pdf'"></el-upload-m>
              </div> -->
            </el-form-item>
          </el-col>
        </el-row>

<!--        <el-row v-if="isOperating">-->
<!--          <el-col :span="6" class="pr20">-->
<!--            <el-form-item label="上架状态" prop="shelf" class="item">-->
<!--              <el-switch-->
<!--                :disabled="$route.query.type == 'check'"-->
<!--                v-model="form.shelf"-->
<!--                active-color="#13ce66"-->
<!--                inactive-color="#ff4949">-->
<!--              </el-switch>-->
<!--            </el-form-item>-->
<!--          </el-col>-->
<!--        </el-row>-->

        <el-row v-if="form.isMallImport">
          <el-col :span="6" class="pr20">
            <el-form-item label="课件总价格" prop="shelf" class="item">
                <el-input
                  :disabled="$route.query.type == 'check'"
                  v-model="form.totalsPrice"
                ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <!--培训资料  -->
        <div class="f--c mb20">
          <h2>
            关联课件1
          </h2>
          <el-button
          class="fa-pull-right"
          v-if="$route.query.type == 'edit'"
          type="primary"
          icon="el-icon-plus"
          @click="showAddData">关联课件
        </el-button>
        </div>
        <associateResource ref="associateResource" style="margin-top: 15px"></associateResource>


        <!--关联考试  -->
        <!-- <div class="f--c mb20">
          <h2>关联考试</h2>
        </div> -->
<!--        <el-button-->
<!--          v-if="$route.query.type == 'edit'"-->
<!--          type="primary"-->
<!--          icon="el-icon-plus"-->
<!--          @click="showCorrelationExam"-->
<!--        >关联考试-->
<!--        </el-button-->
<!--        >-->
<!--        <el-table :data="dataList3" style="width: 100%;margin:20px 0px;">-->
<!--          <el-table-column-->
<!--            prop="questionsPaperName"-->
<!--            label="试卷名称"-->
<!--          ></el-table-column>-->
<!--          <el-table-column label="试卷类型">-->
<!--            <template slot-scope="scope">{{-->
<!--                scope.row.selectionMode == 0 ? "随机试卷" : "固定试卷"-->
<!--              }}-->
<!--            </template>-->
<!--          </el-table-column>-->
<!--          <el-table-column-->
<!--            prop="questionNumber"-->
<!--            label="包含题目数量"-->
<!--          ></el-table-column>-->
<!--          <el-table-column label="操作" v-if="$route.query.type == 'edit'">-->
<!--            <template slot-scope="scope">-->
<!--              <el-button-->
<!--                size="mini"-->
<!--                type="danger"-->
<!--                @click="delPaper(scope.$index)"-->
<!--              >删除-->
<!--              </el-button>-->
<!--            </template>-->
<!--          </el-table-column>-->
<!--        </el-table>-->
        <div class="searchBut" style="text-align: center">
          <el-button @click="$router.back(-1)">返回</el-button>
          <el-button
            v-if="$route.query.type == 'edit'"
            type="primary"
            @click="save"
            :loading="saveLoading"
          >保存
          </el-button>
        </div>
        </div>
      </el-form>
    </div>

    <!--关联课件选择-->
    
    <div class="page_main" v-show="($refs&&$refs.resourcesDataSelector&&$refs.resourcesDataSelector.isShow || false)">
      <div :span="24" class="layer-header-front common_popup_header_top">
        <el-form ref="form" :rules="rules" :model="form" label-width="80px">
        <el-form-item label="课程名称" prop="trainingName" class="item">
          <el-input
            :disabled="$route.query.type == 'check'"
            v-model="form.trainingName"
          ></el-input>
        </el-form-item>
      </el-form>
      </div>
      <resourcesDataSelector ref="resourcesDataSelector" @confirm="confirm"></resourcesDataSelector>
    </div>
    <!--关联考试选择-->
    <examSelector ref="examSelector" @confirm="confirm2"> </examSelector>
    <!--培训分类选择器-->
    <selectTrainingCategory ref="selectTrainingCategory"
                            @submit="selectTrainingCategorySubmitHandle"> </selectTrainingCategory>
  </div>
</template>

<script>

import api from "../../../api/new/training.js";
import api_user from "../../../api/api_user.js";
import exam from "@/api/new/exam.js";
import selectTree from "@/components/common/selectTree";
import selectTrainingCategory from "@/components/training/selectTrainingCategory";

import elUploadE from "@/components/common/oss/ossUpload";
import $ossConstant from "@/components/common/oss/ossConstant";

// import elUploadM from "@/components/common/oss/ossUploadMultiple";


import associateResource from "@/components/training/associateResource";



import {quillEditor} from "vue-quill-editor";
import resourcesDataSelector from '@/pages/trainingManagement/component/resourcesDataSelector.vue';
import examSelector from '@/pages/trainingManagement/component/examSelector.vue';
import * as Quill from 'quill'



/*富文本编辑图片上传配置*/
const uploadConfig = {
  action: process.env.API_ROOT + "/clouddo-tranning/training/record/upload", // 必填参数 图片上传地址
  methods: "POST", // 必填参数 图片上传方式
  // token: window.localStorage.getItem("access-token"), // 可选参数 如果需要token验证，假设你的token有存放在sessionStorage
  name: "file", // 必填参数 文件的参数名
  size: 500, // 可选参数   图片大小，单位为Kb, 1M = 1024Kb
  accept: "image/png, image/gif, image/jpeg, image/bmp, image/x-icon" // 可选 可上传的图片格式
};
const handlers = {
  image: function image() {
    var self = this;

    var fileInput = this.container.querySelector("input.ql-image[type=file]");
    if (fileInput === null) {
      fileInput = document.createElement("input");
      fileInput.setAttribute("type", "file");
      // 设置图片参数名
      if (uploadConfig.name) {
        fileInput.setAttribute("name", uploadConfig.name);
      }
      // 可设置上传图片的格式
      fileInput.setAttribute("accept", uploadConfig.accept);
      fileInput.classList.add("ql-image");
      // 监听选择文件
      fileInput.addEventListener("change", function () {
        // 创建formData
        var formData = new FormData();
        formData.append(uploadConfig.name, fileInput.files[0]);
        formData.append("object", "product");
        // 如果需要token且存在token
        if (uploadConfig.token) {
          formData.append("token", uploadConfig.token);
        }
        // 图片上传
        var xhr = new XMLHttpRequest();
        xhr.open(uploadConfig.methods, uploadConfig.action, true);
        xhr.setRequestHeader(
          "Authorization",
          window.localStorage.getItem("access-token")
        );
        // 上传数据成功，会触发
        xhr.onload = function (e) {
          if (xhr.status === 200) {
            var res = JSON.parse(xhr.responseText);
            let length = self.quill.getSelection(true).index;
            //这里很重要，你图片上传成功后，img的src需要在这里添加，res.path就是你服务器返回的图片链接。
            console.log(res.data);
            self.quill.insertEmbed(length, "image", "http://" + res.data);
            self.quill.setSelection(length + 1);
          }
          fileInput.value = "";
        };
        // 开始上传数据
        xhr.upload.onloadstart = function (e) {
          fileInput.value = "";
        };
        // 当发生网络异常的时候会触发，如果上传数据的过程还未结束
        xhr.upload.onerror = function (e) {
        };
        // 上传数据完成（成功或者失败）时会触发
        xhr.upload.onloadend = function (e) {
          // console.log('上传结束')
        };
        xhr.send(formData);
      });
      this.container.appendChild(fileInput);
    }
    fileInput.click();
  }
};
// toolbar工具栏的工具选项（默认展示全部）
const toolOptions = [
  ["bold", "italic", "underline", "strike"],
  ["blockquote", "code-block"],
  [{header: 1}, {header: 2}],
  [{list: "ordered"}, {list: "bullet"}],
  [{script: "sub"}, {script: "super"}],
  [{indent: "-1"}, {indent: "+1"}],
  [{direction: "rtl"}],
  [{size: ["small", false, "large", "huge"]}],
  [{header: [1, 2, 3, 4, 5, 6, false]}],
  [{color: []}, {background: []}],
  [{font: []}],
  [{align: []}],
  ["clean"],
  ["image"] // "video"
];

import courseUtils from  '@/common/courseUtils.js'

export default {
  components: {quillEditor, selectTree, selectTrainingCategory, resourcesDataSelector, examSelector, associateResource, elUploadE},
  data() {
    return {
      ossConstant: $ossConstant,
      courseUtils: courseUtils,
      id: undefined, //
      type: undefined, //
      selectTreeCategoryVisible: false,
      form: {
        trainingName: undefined,
        implementationDateTime: undefined,
        departmentId: undefined,
        department: undefined,
        principalId: undefined,
        directoryId: undefined,
        directoryName: undefined,
        // principalName: undefined,
        location: undefined,
        trainingContent: undefined,
        shelf: false,
        pictureUrl: undefined,
        teachersId: undefined,

        // training category
        trainingLevelIds: undefined,
        trainingLevelName: undefined,
        trainingIndustryIds: undefined,
        trainingIndustryName: undefined,
        trainingPostIds: undefined,
        trainingPostName: undefined,
        trainingTypeIds: undefined,
        trainingTypeName: undefined,
        trainingCategoryName: undefined,
        isMallImport:undefined,
        sourceId:undefined,
        totalsPrice:undefined
      },
      rules: {
        trainingName: [
          {required: true, message: "请输入课程名称", trigger: "blur"},
          {max: 64, message: '课程名称不能超过64个字', trigger: 'blur' }
        ],
        principalId: [{required: true, message: "请输入"}],
        departmentId: [{required: true, message: "请输入"}],
        directoryId: [{required: true, message: "请选择课程目录"}],
        // trainingContent: [{required: true, message: "请输入课程详情内容"}],
        // pictureUrl: [{required: true, message: "请上传图片"}],
        // trainingCategoryName: [{required: true, message: "请选择课程类型", trigger: "blur"}]
      },
      saveLoading: false,
      correlationExamForm: {
        openBook: undefined,
        selectionMode: undefined,
        questionsPaperName: undefined
      },
      industryMapObj: {}, // 行业字典对象（key: code value: pathName）
      principalList: [], // 负责人列表
      departmentList: [], // 部门列表

      dataForm: {
        dataName: undefined,
        professionalCategory: undefined, // 专业类别
        departmentId: undefined // 部门id
      },
      dataList: [], // 课程资源列表
      selectDataList: [], // 选择的课程资源列表
      selectPaperList: [], // 选择的试卷列表
      dataList2: [], //培训资料列表
      dataList3: [], //试卷列表

      isShowData: false,
      isShowCorrelationExam: false,
      paperList: [], // 试卷列表
      annexList: [], //附件列表

      uploadUrl: "",
      headers: {
        Authorization: ""
      },

      page: 1,
      pageSize: 10,
      total: 0, // 总条数
      page2: 1,
      pageSize2: 20,
      total2: 0,

      deptTree: [],
      dept: {},

      upload: {
        dialogImageUrl: '',
        dialogVisible: false,
        productImgs: [],
        isMultiple: true,
        imgLimit: 1,
        action: process.env.API_ROOT + "/api-base/sysAtt/save"
      },
      editorOption: {
        //  富文本编辑器配置
        placeholder: "",
        theme: "snow", // 主题
        modules: {
          // 新增下面
          imageDrop: true, // 拖动加载图片组件。
          imageResize: {
            //调整大小组件。
            displayStyles: {
              backgroundColor: "black",
              border: "none",
              color: "white"
            },
            modules: ["Resize", "DisplaySize", "Toolbar"]
          },
          toolbar: {
            container: toolOptions, // 工具栏选项
            // handlers: handlers // 事件重写
          }
        },
        history: {
          delay: 1000,
          maxStack: 50,
          userOnly: false
        },
        imageDrop: true,
        imageResize: {
          displayStyles: {
            backgroundColor: "black",
            border: "none",
            color: "white"
          },
          modules: ["Resize", "DisplaySize", "Toolbar"]
        }
      },
      catalogList: [], // 试题目录
      teachersOptions: [],  // 教师options
      // addRange: [], // 视频
      // fullscreenLoading: false,
      // uploadType: ''
    };
  },
  mounted() {
    // 为图片ICON绑定事件  getModule 为编辑器的内部属性
    // this.$refs.myQuillEditor.quill.getModule('toolbar').addHandler('video', this.videoHandler);

    this.id = this.$route.query.id;
    this.type = this.$route.query.type;
    if (this.id) this.getProgramDetail();
    this.departmentList = JSON.parse(localStorage.getItem("departmentList"));
    this.industryMapObj = JSON.parse(localStorage.getItem("categoryList"));
    this.deptTree = JSON.parse(localStorage.getItem("deptTree"));
    this.uploadUrl =
      process.env.API_ROOT + "/clouddo-tranning/training/resources/data/upload";
    this.headers.Authorization = window.localStorage.getItem("access-token");
    this.loadTeachersOptions();
    this.getCatalogList();
  },
  methods: {
    showSelectTreeCategoryVisible() {
      this.$refs.trainingCategoryInput.blur();
      this.$refs.selectTrainingCategory.showDialog();
    },
    trainingCategoryClear(){
      this.form.trainingLevelName = undefined;
      this.form.trainingLevelIds = undefined;
      this.form.trainingIndustryName = undefined;
      this.form.trainingIndustryIds = undefined;
    },
    deptChange(v) {
      this.dept = v;
      this.form.departmentId = v.id;
    },
    pageChange(e) {
      this.page = e;
      this.getDataList();
    },
    getProgramDetail() {
      api.getProgramDetail({programId: this.id}).then(res => {
        this.form.trainingName = res.data.trainingName;
        this.form.implementationDateTime = res.data.implementationTime;
        this.form.departmentId = parseInt(res.data.departmentId);
        this.form.department = res.data.department;
        this.form.principalId = parseInt(res.data.principalId);
        this.form.principalName = res.data.principalName;
        this.form.location = res.data.location;
        this.form.trainingContent = res.data.trainingContent;
        this.form.pictureUrl = res.data.pictureUrl;
        this.annexList = res.data.annexList;
        // this.form.shelf = res.data.shelf;
        this.form.directoryId = res.data.directoryId;
        this.form.teachersId = res.data.teachersId;

        this.form.trainingLevelName = res.data.trainingLevelName;
        this.form.trainingLevelIds = res.data.trainingLevelIds;
        this.form.trainingIndustryName = res.data.trainingIndustryName;
        this.form.trainingIndustryIds = res.data.trainingIndustryIds;
        this.form.trainingPostName = res.data.trainingPostName;
        this.form.trainingTypeName = res.data.trainingTypeName;
        this.form.trainingCategoryName = res.data.trainingCategoryName;
        this.form.isMallImport=res.data.isMallImport;
        this.form.sourceId=res.data.sourceId;
        this.form.totalsPrice=res.data.totalsPrice;

        // res.data.trainingProgramJoinDataVos.forEach(v => {
        //   if (v.professionalCategory && this.industryMapObj[v.professionalCategory]) {
        //     v.categoryName = this.industryMapObj[v.professionalCategory];
        //   }
        // });
        // 回显
        this.dataList2 = res.data.trainingProgramJoinDataVos;
        this.$nextTick(() => {
          this.$refs.associateResource.setDataList(this.dataList2,"2");
        })
        if (res.data.trainingProgramJoinPaperVos) {
          res.data.trainingProgramJoinPaperVos.forEach(v => {
            v.questionNumber = v.questionsNumber;
          });
        }
        this.dataList3 = res.data.trainingProgramJoinPaperVos;
        // 图片回显
        this.upload.productImgs = [{name: '课程图片', url: res.data.pictureUrl}];

      });
    },
    save() {
      this.$refs.form.validate(validate => {
        if (validate == false) return;

        let p = {
          ...this.form,
          trainingProgramJoinDataSaveDtos: [],
          trainingProgramJoinPaperSaveDtos: [],
          annexList: this.annexList,
          enterpriseId: JSON.parse(localStorage.getItem("userinfo"))
            .enterpriseId
        };

        delete p.trainingCategoryName;
        delete p.totalsPrice;

        //清空附带数据
        p.pictureUrl = undefined;
        
        // 关联课件
        this.dataList2.forEach(v => {
          p.trainingProgramJoinDataSaveDtos.push({
            trainingResourcesDataId: v.id ? v.id : v.trainingResourcesDataId,
            dataName: v.dataName,
            professionalCategory: v.professionalCategory,
            department: v.department,
            departmentId: v.departmentId,
            dataType: v.dataType,
            paperId: v.paperId,
            feedbackType: v.feedbackType
          });
        });

        if (this.dataList3 && this.dataList3.length > 0) {
          this.dataList3.forEach(v => {
            p.trainingProgramJoinPaperSaveDtos.push({
              questionsPaperId: v.id || v.questionsPaperId,
              questionsPaperName: v.questionsPaperName,
              questionsPaperType:
                v.selectionMode !== undefined
                  ? v.selectionMode
                  : v.questionsPaperType,
              questionsNumber:
                v.questionsNumber !== undefined
                  ? v.questionsNumber
                  : v.questionNumber
            });
            console.log(v.selectionMode || v.questionsPaperType);
            console.log(v.selectionMode || v.questionsPaperType);
          });
        }



        this.departmentList.forEach(v => {
          if (p.departmentId == v.id) p.department = v.deptName;
        });

        if (this.id) p.id = this.id;
        if (p.trainingProgramJoinDataSaveDtos.length == 0)
          return this.$message.error("请添加培训课件");
        this.saveLoading = true;
        api.addProgram(p).then(res => {
          if (res.code == 0) {
            this.$message.success("成功");
            this.$router.go(-1);
          } else {
            this.saveLoading = false;
            this.$message.error(res.message);
          }
        });
      });
    },
    //上传文件成功回调
    uploadSuccess(e) {
      if (e.code == 0) {
        this.annexList.push(e.data);
      } else {
        this.$message.error(e.message);
      }
    },
    delData(index) {
      this.$confirm("此操作将删除, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        this.dataList2.splice(index, 1);
      });
    },
    delPaper(index) {
      this.$confirm("此操作将删除, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        this.dataList3.splice(index, 1);
      });
    },
    // 添加培训资料,确定
    confirm(selectDataList) {
      this.dataList2 = [];
      selectDataList.forEach(v => {
        this.dataList2.push(v);
      });
      this.$refs.associateResource.setDataList(this.dataList2,"2");
    },
    // 关联考试,确定
    confirm2(selectDataList) {
      this.dataList3 = [];
      selectDataList.forEach(v => {
        this.dataList3.push(v);
      });
    },
    showAddData() {
      this.$refs.resourcesDataSelector.show();
      this.$refs.resourcesDataSelector.setSelection(this.dataList2);
    },
    showCorrelationExam() {
      this.$refs.examSelector.show();
      this.$refs.examSelector.setSelection(this.dataList3);
    },
    //重置表单
    resetForm(formName) {
      console.log(formName);
      this.$refs[formName].resetFields();
    },
    //  图片上传回调代码
    handleRemove(file, fileList) {//移除图片
      this.upload.productImgs = fileList;
    },
    handlePictureCardPreview(file) {//预览图片时调用
      console.log(file);
      this.upload.dialogImageUrl = file.url;
      this.upload.dialogVisible = true;
    },
    beforeAvatarUpload(file) {//文件上传之前调用做一些拦截限制
      console.log(file);
      const isJPG = true;
      // const isJPG = file.type === 'image/jpeg';
      const isLt2M = file.size / 1024 / 1024 < 2;

      // if (!isJPG) {
      //   this.$message.error('上传头像图片只能是 JPG 格式!');
      // }
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 2MB!');
      }
      return isJPG && isLt2M;
    },
    handleAvatarSuccess(res, data) {//图片上传成功
      this.form.picture = data.name;
      this.form.pictureUrl = data.url;
    },
    handleExceed(files, fileList) {//图片上传超过数量限制
      this.$message.error('只能上传' + this.upload.imgLimit + '张图片');
      console.log(file, fileList);
    },
    imgUploadError(err, file, fileList) {//图片上传失败调用
      console.log(err)
      this.$message.error('上传图片失败!');
    },
    getCatalogList() {
      exam.getCatalogList({
        type: 4,
        enterpriseId: JSON.parse(localStorage.getItem("userinfo"))
          .enterpriseId
      })
        .then(res => {
          this.catalogList = res.data;
        });
    },
    loadTeachersOptions() {
      exam.getTeachersOptions({}).then(res => {
        this.teachersOptions = res.data;
      });
    },
    selectTreeChange(v) {
      this.form.directoryId = v.id
      this.form.directoryName = v.text;
    },
    showSelectTreeCategory() {
      this.selectTreeCategoryVisible = true;
    },
    selectTrainingCategorySubmitHandle(data) {
      this.form.trainingLevelIds = data.trainingLevelId? [data.trainingLevelId] : undefined;
      this.form.trainingLevelName = data.trainingLevelName;

      this.form.trainingIndustryIds =  data.trainingIndustryId? [data.trainingIndustryId] : undefined;
      this.form.trainingIndustryName = data.trainingIndustryName;
      //
      // this.form.trainingPostIds = [data.trainingPostId];
      // this.form.trainingPostName = data.trainingPostName;
      //
      // this.form.trainingTypeIds = [data.trainingTypeId];
      //   this.form.trainingTypeName = data.trainingTypeName;

      this.form.trainingCategoryName = data.trainingCategoryName;

      this.$refs.form.validateField("trainingCategoryName");
    },
    /**
     * 判断是否是运营人员
     */
    isOperating(){
      let userInfo = JSON.parse(localStorage.getItem('userinfo'));
      return userInfo.isOperating;
    },
    
    /**
     * 上传之前
     **/
     uploadBefore(file) {
      let fileType = file.name.split('.').pop().toLowerCase();
      // if (fileType == 'mp4') {
      //   this.getTimes(file);
      // }
    },
    /**
     * 上传文件成功回调
     */
    uploadSuccess2(e, data) {
      console.log('uploadSuccess2', data);
      this.fullscreenLoading = false;
      let vm = this
      if (data && data.url) {  // 将文件上传后的URL地址插入到编辑器文本中
        let value = data.url
        vm.addRange = vm.$refs.myQuillEditor.quill.getSelection();
        value = value.indexOf('http') !== -1 ? value : 'http:' + value;
        vm.$refs.myQuillEditor.quill.insertEmbed(vm.addRange !== null ? vm.addRange.index : 0, vm.uploadType, value, Quill.sources.USER)   // 调用编辑器的 insertEmbed 方法，插入URL
      } else {
        this.$message.error(`${vm.uploadType}插入失败`)
      }
      // this.tableData[this.tableIndex].resourcesUrl = data.url;
      // this.tableData[this.tableIndex].resourcesPath = data.name;
      // // this.tableData[this.tableIndex].resourcesFileId = data.hash
      // if (data.name.indexOf(".pdf") > -1 || data.name.indexOf(".PDF") > -1) {
      //   this.tableData[this.tableIndex].resourcesType = 0;
      // } else {
      //   this.tableData[this.tableIndex].resourcesType = 1;
      // }
    },
    // 点击视频ICON触发事件
    videoHandler(state) {
      console.log('videoHandler', state);
      this.addRange = this.$refs.myQuillEditor.quill.getSelection();
      if (state) {
        let fileInput = document.getElementById('imgInput')
        fileInput.click() // 加一个触发事件
      }
      this.uploadType = 'video'
    }
  },
  watch: {
    "form.departmentId": function (deptId) {
      api_user.getByDept({deptId}).then(res => {
        this.principalList = res.data;
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.el-form-item__label {
  white-space: nowrap;
}

.required {
  color: red;
}

.hr {
  height: 2px;
  background: #e4e4e4;
  flex: 1;
  margin-left: 20px;
}

.f--c {
  margin-top: 25px;
  margin-bottom: 30px;
}
.page_main{
  background: #fff;
  overflow: hidden;
  .common_popup_header_top{
    .el-form{
      padding-top: 11px;
    }
  }
  .BatchBox{
    margin-top: 0;
  }
}
.ql-snow .ql-tooltip[data-mode=video]::before {
      content: "请输入视频地址:";
  }
</style>



// WEBPACK FOOTER //
// src/pages/trainingManagement/course/addCourse.vue